import { ready } from './utils/dom';
import { init as Accordion } from './modules/accordion';
import { init as Alert } from './modules/alert';
import { init as Cookies } from './modules/cookie-script';
import { init as Animation } from './modules/animation';
import { init as BookingForm } from './modules/booking-form';
import { init as Carousel } from './modules/carousel';
import { init as Curtains } from './modules/curtains';
import { init as Disclosure } from './modules/disclosure';
import { init as ExitIntent } from './modules/exit-intent';
import { init as GoogleMaps } from './modules/google-maps';
import { init as HeaderNav } from './modules/header-nav';
import { init as HorizontalMenu } from './modules/horizontal-menu';
import { init as ImageCarousel } from './modules/image-carousel';
import { init as InstagramFeed } from './modules/instagram-feed';
import { init as Modal } from './modules/modal';
import { init as Navigation } from './modules/navigation';
import { init as Newsletter } from './modules/newsletter';
import { init as QuickJump } from './modules/quick-jump';
import { init as SpinButton } from './modules/spinbutton';
import { init as StickyHeader } from './modules/sticky-header';
import { init as StickyFooter } from './modules/sticky-footer';
import { init as FauxLink } from './modules/fuax-link';
import { init as video } from './modules/video';
import { LazyLoader } from './modules/lazy-loader';

ready(function onReady() {
	init();

	/*
	 * We have a class on the document root that disables all css transitions in
	 * order to avoid flashes as the scripts initialise which may add classes based on
	 * state. Once we're done initialising we re-enable them by removing this class.
	 */
	window.requestAnimationFrame(() => {
		document.documentElement.classList.remove('no-transition');
	});
});

function init() {
	LazyLoader().update();
	Animation();
	Curtains();
	Accordion();
	Alert();
	Cookies();
	HeaderNav();
	Modal();
	Navigation();
	Newsletter();
	QuickJump();
	SpinButton();
	BookingForm();
	StickyHeader();
	StickyFooter();
	Carousel();
	ImageCarousel();
	InstagramFeed();
	ExitIntent();
	HorizontalMenu();
	Disclosure();
	GoogleMaps();
	FauxLink();
	video();
}
